<template>
  <div>
    <keep-alive>
      <router-view :key="$route.fullPath" class="lv2Text"></router-view>
    </keep-alive>
    <el-dialog  :visible.sync="dialogVisible" width="50%" :show-close="false">
      <h2 style="font-size:28px">提示:</h2>
      <div style="padding:50px 0;font-size:26px">是否前去下载宝枫林app？前去单击确定按钮，留在此页面请单击取消按钮</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="call" style="width:200px;padding:10px 0">取 消</el-button>
        <el-button type="primary" @click="enter" style="width:200px;padding:10px 0">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {
  data() {
    return {
      dialogVisible: false
    };
  },
  methods: {
    call() {
      this.$cookies.set("app", 1,"1d");
      this.dialogVisible = false;
    },
    enter() {
       window.location.href = "https://www.bioflin.com:83/app/index.html"
    }
  },
  mounted() {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isAndroid) {
      const cookie = this.$cookies.get("app");
      if (cookie != "1") {
        this.$cookies.set("app", 0);
        this.dialogVisible = false;
      }
    }
    if (isiOS) {
      const cookie = this.$cookies.get("app");
      if (cookie != "1") {
        this.$cookies.set("app", 0);
        this.dialogVisible = false;
      }
    }
  }
};
</script>
<style lang="scss">
$--color-primary: #e2211c;
a {
  text-decoration: none;
  color: #606266;
}
.bread {
  padding: 20px 0;
  color: #999;
}
</style>